// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__4h-Ls","location":"Header_location__1r9sE"};